import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { FormContainer, SelectElement } from 'react-hook-form-mui';
import { defineMessages, useIntl } from 'react-intl';
import { z } from 'zod';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';

export const twitterSettingsSchema = z.object({
  replySettings: z
    .nativeEnum(socialExport.TwitterSettingsDtoReplySettingsEnum)
    .nullable()
    .optional(),
});

const replySettingsMessages = defineMessages({
  everyone: {
    id: 'socialExport.twitter.replyEveryone',
    defaultMessage: 'Todos',
  },
  following: {
    id: 'socialExport.twitter.replyFollowing',
    defaultMessage: 'Personas que sigues',
  },
  mentionedUsers: {
    id: 'socialExport.twitter.replyMentioned',
    defaultMessage: 'Usuarios mencionados',
  },
  subscribers: {
    id: 'socialExport.twitter.replySubscribers',
    defaultMessage: 'Suscriptores',
  },
  verified: {
    id: 'socialExport.twitter.replyVerified',
    defaultMessage: 'Verificados',
  },
});

export function TwitterSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.TwitterSettingsDto>) {
  const { $t, formatMessage } = useIntl();
  const replySettingsOptions = Object.values(socialExport.TwitterSettingsDtoReplySettingsEnum).map(
    (value: socialExport.TwitterSettingsDtoReplySettingsEnumKey) => ({
      id: value,
      label: formatMessage(replySettingsMessages[value as keyof typeof replySettingsMessages]),
    }),
  );

  return (
    <FormContainer
      mode="onBlur"
      values={{
        replySettings: defaultSettings.replySettings,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          replySettings: formData.replySettings,
        });
      }}
      resolver={zodResolver(twitterSettingsSchema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.defaultValuesUploads',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <Grid container>
          <Grid item md={3}>
            <SelectElement
              name="replySettings"
              label={$t({
                id: 'socialExport.form.replyConfig',
                defaultMessage: 'Configuración de respuestas',
              })}
              options={replySettingsOptions}
              fullWidth
            />
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
